import {GeneralAction, UserPayload} from '../../../@types/actions';
import {EVENT_INITIALIZE} from '../../../constants/EventsConstants';

export const GetInitAction = (userId: string): GeneralAction<UserPayload> => ({
    type: EVENT_INITIALIZE,
    payload: {userId}
});
